export const DESKTOP_MEDIA = 1200
export const HD_MEDIA = 1440
export const MAC_MEDIA = 1620
